/**
 * Stiene til lekeplassen (se api/playground.ts).
 *
 * Skjemaene kjører under egne ruter med de samme skjermene som søkeren ser:
 *   /lekeplass/soknad/:formType/…              søknadsskjema
 *   /lekeplass/rapport/:applicationType/:formType/…  rapport; `applicationType`
 *       er søknadstypen rapportbetingelsene evalueres mot (0 = ingen bestemt)
 */
export const PLAYGROUND_HOME = '/din-side/lekeplass';
export const PLAYGROUND_DONE = '/lekeplass/ferdig';

/** Det ferdigskjermen får med seg i `location.state`. */
export type PlaygroundDoneState = {
    title?: string;
    // Stien «Prøv igjen» går til — skjemaets start, med tomt skjema.
    retry?: string;
};
